<script type="text/jsx" lang="jsx">
import { mapGetters } from 'vuex';
import { computedPbxBasePlans, computedPbxPlans, PBX_SUB_TYPES } from '@/common/service/computers/plans/pbx';
import mixin from '@/plans/mx/shopping-cart';
import zEduMixin from '@/plans/ZONE_EDU_PLUS/mixin';
import { plansof } from '@/utils/chain';
import { planTypes } from '@/common/constants';
import { logger } from '@/utils/log';
import AltProratedPlanUser from '@/views/config/shopping-cart/prorated/plan-user.vue';
import AltProratedPlanPrice from '@/views/config/shopping-cart/prorated/plan-price.vue';
import AltProratedPlanPeriod from '@/views/config/shopping-cart/prorated/plan-period.vue';
import AltProratedPlanMultiple from '@/views/config/shopping-cart/prorated/multiple.vue';

export default {
  mixins: [mixin, zEduMixin],
  components: {
    AltProratedPlanUser,
    AltProratedPlanPrice,
    AltProratedPlanPeriod,
    AltProratedPlanMultiple,
  },
  computed: {
    ...mapGetters(['getSelectedPlans']),
    selectedPbxPlans() {
      return computedPbxPlans(this.getSelectedPlans);
    },
    pbxAddonPlans() {
      return this.selectedPbxPlans.filter(item => [PBX_SUB_TYPES.FEATURE, PBX_SUB_TYPES.UNLIMITED_ADDON].includes(item.sub_type));
    },
    hasPbxCart() {
      return this.filterKeys.includes('ZOOM_PHONE');
    },
  },

  methods: {
    $renderCallingPlan() {
      const callingPlans = plansof(this.getSelectedPlans).type(planTypes.ZONE_EDU_PLUS).get();
      if (!callingPlans.length) return;

      return callingPlans.map((p) => {
        return (
          <div class="pbx-cart-part">
            {this.mx_subTitle(
              this.$t(`billing.pbx.cart_name.${p.pbxCategory}`),
              this.mx_price(p),
              p?.plan_code
            )}
            {this.mx_discount(p.plan_code)}
            {this.mx_cycle(p.billing_cycle)}
            {this.mx_new_license(p, p.cartInfo.selected_number)}
            {this.mx_edit(p)}
          </div>
        );
      });
    },
    $renderPbxBasePlan() {
      const pbxBasePlan = computedPbxBasePlans(this.getSelectedPlans)[0];
      if (!pbxBasePlan) return null;
      if (this.hasPbxCart) return null;

      return (
        <div class="pbx-cart-part">
          {this.mx_subTitle(this.$t('billing.pbx.calling_fee_name.pay_you_go.MC'), pbxBasePlan.amount, pbxBasePlan?.plan_code)}
          {this.mx_discount(pbxBasePlan.plan_code)}
          {this.mx_cycle(pbxBasePlan.billing_cycle)}
          {this.mx_edit(pbxBasePlan)}
        </div>
      );
    },

    mergePlans (planList) {
      if(!Array.isArray(planList)) {
        return [];
      }
      return planList.reduce((acc, cur) => {
        if(Array.isArray(cur)) {
          return [...acc, ...cur];
        }
      }, [])
    },

    renderMainTitle () {
      const callingPlans = plansof(this.getSelectedPlans).type(planTypes.ZONE_EDU_PLUS).get();
      const pbxBasePlan = computedPbxBasePlans(this.getSelectedPlans);
      const plans = this.mergePlans([callingPlans, pbxBasePlan]);
      return plans.map((item, index) => {
        if(!index) {
          return  this.mx_title(this.title, undefined, undefined, item.parent_category, ['text-no-capitalize'])
        }
        return <div style='display: none;'>{this.mx_title(this.title, undefined, undefined, item.parent_category, ['text-no-capitalize'])}</div>
      })
    },

    $renderPbxAddons() {
      if (!this.pbxAddonPlans?.length) return null;
      if (this.hasPbxCart) return null;

      logger.info("render pbx addon plan in edu plus context");

      return <div class="opc-cart-item">
        <h1 class="opc-cart-item__title text-capitalize">{this.$t('billing.planform.title.zoomphone')}</h1>
        {
          this.pbxAddonPlans.map(item => (
            <AltProratedPlanMultiple code={item.plan_code} key={item.plan_code}>
            <div class="pbx-cart-part" key={item.plan_code}>
              {this.mx_subTitle(this.$t(`billing.pbx.plan_name.${item.category}`), <AltProratedPlanPrice code={item.plan_code}>{this.$money(this.mx_price(item))}</AltProratedPlanPrice>, item.plan_code)}
              {this.mx_discount(item.plan_code)}
              <AltProratedPlanUser code={item.plan_code}>
              {this.mx_license(item.cartInfo.selected_number, this.$t('billing.planform.unit.number'))}
              </AltProratedPlanUser>
              {this.mx_cycle(item.billing_cycle)}
              <AltProratedPlanPeriod code={item.plan_code} />
              {this.mx_edit(item)}
            </div>
            </AltProratedPlanMultiple>
          ))
        }
      </div>;
    },

    $renderPrice() {
      return (
        <div>
          <div class="opc-cart-item">
            { this.renderMainTitle()}
            { this.$renderCallingPlan() }
            { this.$renderPbxBasePlan() }
          </div>
          {this.$renderPbxAddons()}
        </div>
      );
    },
  },
};
</script>
